import React, { useState, useRef } from 'react';

import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import StopCircleIcon from '@mui/icons-material/StopCircle';
import { SxProps, Theme, useTheme } from '@mui/material';

interface Props {
  sx : SxProps<Theme>;
  playbackUrl : string | null,
  onRecordingCompleted : (url : string) => void
}

const ProfileRecorder = React.forwardRef(({ sx, playbackUrl, onRecordingCompleted } : Props, ref) => {
  const [state, setState] = useState('idle');

  const recordedChunks = useRef<Blob[]>([]);
  const mediaRecorder = useRef<MediaRecorder | null>(null);
  const audioPlayer = useRef<HTMLAudioElement | null>(null);
  const bgmPlayer = useRef<HTMLAudioElement | null>(null);

  const theme = useTheme();

  const startRecord = () => {
//    console.log('startRecord');
    const handleSuccess = function(stream : MediaStream) {
  //    console.log('success');

      let mime = 'audio/webm';

      if(!MediaRecorder.isTypeSupported(mime)) {
        mime = 'audio/mp4';
      }

      const options = {mimeType: mime};

      let chunks : Blob[] = [];
      recordedChunks.current = chunks;

      let recorder = new MediaRecorder(stream, options);
      mediaRecorder.current = recorder;

      recorder.addEventListener('dataavailable', function(e) {
        if (e.data.size > 0) chunks.push(e.data);
      });

      recorder.addEventListener('stop', function() {
//        let oldUrl = sessionStorage.getItem(path);
        console.log('chunk', chunks[0]);
        let newUrl =  URL.createObjectURL(chunks[0]);

        console.log('newUrl', newUrl);

        onRecordingCompleted(newUrl);

        stream.getTracks().forEach(track => track.stop());
        mediaRecorder.current = null;

        setState('idle');
      });

      recorder.start();

      setState('record');
    };

    navigator.mediaDevices.getUserMedia({ audio: true, video: false })
        .then(handleSuccess)
        .catch(function(err) {
          alert(err);
      });
  }

  const stopRecord = () => {
    mediaRecorder.current?.stop();
  }

  const startPlay = () => {
    if(!playbackUrl) return;

    const bgmNames = ['1W', '2C', '3F', '4F', '5G', '6H', '7H', '8L', '9P'];
    const bgmName = bgmNames[Math.floor(Math.random() * bgmNames.length)];
    const bgmUrl = `/BGM/${bgmName}.mp3`;

    bgmPlayer.current = new Audio(bgmUrl);
    audioPlayer.current = new Audio(playbackUrl);

//    bgmPlayer.current.volume = 0.5;
        bgmPlayer.current.play(); bgmPlayer.current.pause();
        audioPlayer.current.play(); audioPlayer.current.pause();

    let count = 2;
    const trigger = () => {
      count -= 1;
      if(count === 0) {
        bgmPlayer.current?.play();
        audioPlayer.current?.play();
      }
    }
    bgmPlayer.current.addEventListener('error', trigger);
    bgmPlayer.current.addEventListener('canplaythrough', trigger);
    audioPlayer.current.addEventListener('canplaythrough', trigger);
    audioPlayer.current.addEventListener('play', function() {
      setState('play');
    });

    audioPlayer.current.addEventListener('ended', function() {
      stopPlay();
    });
  }

  const stopPlay = () => {
    let audio = audioPlayer.current;
    if(audio != null) {
      audio.pause();
      audio.src = '';
    }

    audioPlayer.current = null;

    if(bgmPlayer.current) {
      bgmPlayer.current.pause();
      bgmPlayer.current.src = '';
      bgmPlayer.current = null;
    }
    setState('idle');
  }

  return (
    <Stack ref={ref} direction='row' spacing={5} sx={{...sx, display: 'inline-flex', px:'0px' }}>
      {state === 'record' ?
      <Button
        sx={{textTransform:'none', color:'red'}}
        onClick={stopRecord}
      >
        <StopCircleIcon fontSize='large' sx={{mr:1}} />
        Stop      ‏‏‎ ‎
      </Button>
      :
      <Button sx={{
        textTransform:'none', color:theme.palette.text.primary,
        ...(state !== 'idle') && {visibility:'hidden'}}}
        onClick={startRecord}
        >
        <RadioButtonCheckedIcon fontSize='large' sx={{mr:1}} />
        Record
      </Button>
      }
      {state === 'play' ?
        <Button sx={{textTransform:'none', color:'green'}} onClick={stopPlay}>
          <StopCircleIcon fontSize='large' sx={{mr:1}} />
          Stop        ‎
        </Button>
        :
        <Button sx={{
          textTransform:'none', color:theme.palette.text.primary,
          ...(state !== 'idle') && {visibility:'hidden'}}}
          disabled={playbackUrl === null}
          onClick={startPlay}>
          <PlayCircleIcon fontSize='large' sx={{mr:1}} />
          Play
        </Button>
      }
    </Stack>
  );
});

export default ProfileRecorder
